import React from "react";

import { Button } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { confirmVerifyPickFinished } from "../../../lib/store/reducers/conveyorBoxReviewReducer";
import { IConveyorBoxUI } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import { useSelector } from "react-redux";
import useVerifyItemsA2 from "../../../hooks/useVerifyItems/useVerifyItemsA2";

const ConfirmVerifyPickFinishedButton = () => {
  const dispatch = useDispatch();
  const conveyorBoxReview: IConveyorBoxUI = useSelector(
    (state: any) => state.conveyorBoxReviewReducer
  );
  const items = conveyorBoxReview.items.active;
  const { isAllItemsVerified } = useVerifyItemsA2({
    items: items,
  });

  if (isAllItemsVerified) return null;

  return (
    <Button
      onClick={() => dispatch(confirmVerifyPickFinished())}
      content="Skannat klart"
      size="big"
      inverted
      color="green"
      aria-label="Skannat klart"
      // icon="exclamation"
    />
  );
};

export default ConfirmVerifyPickFinishedButton;
